import createModel, { Mapped } from "@/__main__/data-model.mjs";

export default createModel({
  default_mode: {
    mode: String,
    nb_games: Number,
    nb_clusters: Number,
  },
  modes_default_rank: Mapped({
    key: String,
    value: {
      rank: String,
      nb_games: Number,
      nb_clusters: Number,
    },
  }),
});
